// Extractor puro, no atado a inventory: dado un error de axios, deserializa el body
// (tolera string crudo —el proxy lo relaya así— o ya parseado) y devuelve errors[{code,message}] o [].
export function extractApiErrorCodes(error) {
    let data = error?.response?.data;
    if (data == null)
        return [];

    if (typeof data === "string") {
        try {
            data = JSON.parse(data);
        } catch {
            return [];
        }
    }

    const errors = data?.errors;
    if (!Array.isArray(errors))
        return [];

    return errors
        .filter(e => e && e.code != null)
        .map(e => ({ code: e.code, message: e.message }));
}
